import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-km-navigation',
  templateUrl: './km-navigation.component.html',
  styleUrls: ['./km-navigation.component.scss']
})
export class KmNavigationComponent implements OnInit {
  navbarCollapsed = false;
  mobileView = false;

  constructor(public breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 992px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.mobileView = true;
        } else {
          this.mobileView = false;
        }
      });
  }
}
